var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyframeTickmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4112_41476)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4112_41476",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.54288 0 0 3.54285 0 8C0 12.4572 3.54288 16 8 16C12.4571 16 16 12.4572 16 8C16 3.54285 12.4571 0 8 0ZM8 14.8571C4.22858 14.8571 1.14285 11.7715 1.14285 8C1.14285 4.22852 4.22858 1.14294 8 1.14294C11.7714 1.14294 14.8571 4.22852 14.8571 8C14.8571 11.7715 11.7714 14.8571 8 14.8571ZM6.85715 11.2001L4 8.3429L4.91428 7.42859L6.85715 9.37146L11.0857 5.14294L12 6.05725L6.85715 11.2001Z",
    fill: "#368A04"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4112_41476)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4112_41476",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -2,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.14258 17.1432H17.1432V-1.14258H-1.14258V17.1432Z",
    fill: "#368A04"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4112_41476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.71387 -5.71387H21.7147V21.7146H-5.71387V-5.71387Z",
    fill: "#368A04"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4112_41476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyframeTickmark);
export default __webpack_public_path__ + "static/media/keyframeTickmark.bfe1e15520865bf1cd618a5591021d03.svg";
export { ForwardRef as ReactComponent };